module.exports = __webpack_public_path__ + "static/media/b17468ea-cf53-4635-984b-4d930a68ed4d.1584837a.woff2";